import { render } from "./SidebarItem.vue?vue&type=template&id=5a8fcc18"
import script from "./SidebarItem.vue?vue&type=script&lang=js"
export * from "./SidebarItem.vue?vue&type=script&lang=js"

import "./SidebarItem.vue?vue&type=style&index=0&id=5a8fcc18&lang=css"

import exportComponent from "/Users/suryaardiansah/Documents/Project/Programming/Vue/BACKUPP/vue-backup/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__